// extracted by mini-css-extract-plugin
export default {"SliderItems":"SliderItems_SliderItems__yM3fa","actions":"SliderItems_actions__JGrtg"};